/* eslint-disable no-unused-vars */
import { LeadServiceJava } from "../../../service/lead-service-java-api";

const checkLeadPhoneNumber = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.checkLeadPhoneNumber(data)
            .then((response) => {
                resolve(response.data.detail);
            }).catch((error) => {
                reject(error);
            });
    });
};

const sendOtpViaLeadToken = (token, sourceChannel = "") => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.sendOtpViaLeadToken(token, sourceChannel)
            .then((response) => {
                resolve(response.data.detail);
            }).catch((error) => {
                reject(error);
            });
    });
};

const verifyOtpViaLeadToken = (data, query = "") => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.verifyOtpViaLeadToken(data, query)
            .then((response) => {
                resolve(response.data.detail);
            }).catch((error) => {
                reject(error);
            });
    });
};

const getRepeatInspectionDetails = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getRepeatInspectionDetails(data)
            .then((response) => {
                resolve(response.data.detail);
            }).catch((error) => {
                reject(error);
            });
    });
};

export {
    checkLeadPhoneNumber,
    sendOtpViaLeadToken,
    verifyOtpViaLeadToken,
    getRepeatInspectionDetails
};
